import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { useRef, useState } from "react";
import "leaflet/dist/leaflet.css";
import "./Maps.css";
import L from "leaflet";
import { buildQueries } from "@testing-library/react";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require("leaflet/dist/images/red-marker1c.png"),
//   iconUrl: require("leaflet/dist/images/red-marker1c.png"),
//   shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
// });

function Maps() {
  const pagewidth = window.innerWidth;
  const [small, setsmall] = useState(false);
  useEffect(() => {
    if (pagewidth <= 960) {
      setsmall(true);
    } else if (pagewidth > 960) {
      setsmall(false);
    }
    console.log(small)
  }, small);
  return (
    <div className="cust">
      {!small && (
        <>
          <MapContainer
            center={[19.133724135198904, 72.913224981729]}
            zoom={14}
            scrollWheelZoom={false}
            style={{ width: "100%", height: "500px" }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              // url="https://api.maptiler.com/maps/topographique/256/{z}/{x}/{y}.png?key=jtMSWtSUpdSv3a1fneUg"
              // attribution='<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
            />
            <Marker position={[19.133724135198904, 72.913224981729]}>
              <Popup>MY LOCATION</Popup>
            </Marker>
          </MapContainer>
        </>
      ) }
      {small && (
        <>
          <MapContainer
            center={[19.133724135198904, 72.913224981729]}
            zoom={14}
            scrollWheelZoom={false}
            style={{ width: "80%", height: "70vh" }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              // url="https://api.maptiler.com/maps/topographique/256/{z}/{x}/{y}.png?key=jtMSWtSUpdSv3a1fneUg"
              // attribution='<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
            />
            <Marker position={[19.133724135198904, 72.913224981729]}>
              <Popup>MY LOCATION</Popup>
            </Marker>
          </MapContainer>
        </>
      )}
    </div>
  );
}

export default Maps;
